import { gql } from 'apollo-angular';

export const QUALTRICS_SURVEY_FEEDBACK_SUBMIT = gql`
  mutation SurveyResponseSubmission(
    $values: JSON!
    $surveyId: Int!
    $qualtricsSurveyId: String!
    $versionNumber: Int!
    $responseId: String!
    $triggerConfigurationId: Int!
  ) {
    SurveyResponseSubmission(
      surveySubmissionRequest: {
        qualtricsMsg: { values: $values }
        surveyDetails: {
          surveyId: $surveyId
          qualtricsSurveyId: $qualtricsSurveyId
          versionNumber: $versionNumber
          responseId: $responseId
          triggerConfigurationId: $triggerConfigurationId
        }
      }
    ) {
      isSuccess
      message
      errorCode
      data
    }
  }
`;
